import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Mousewheel } from "swiper/modules";
import "swiper/swiper-bundle.css";

const Sptp = () => {
  const location = useLocation();

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | SPTP 종합심리검사`;

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });
  }, [location]);

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/presence">아소비 입회</a>
              </li>
              <li>
                <a href="/diagnostic">진단 테스트</a>
              </li>
              <li>
                <a href="/sptp" className="sel">
                  SPTP 종합심리검사
                </a>
              </li>
              <li>
                <a href="/branch">우리 동네 아소비</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="subvisual">
          <div className="title">아소비 입회</div>
          <div className="text">
            초등학교 입학 전후, 우리 아이 교육이 걱정되신다면 <br />
            지금 유기농공부 아소비로 시작해보세요!
          </div>
          <div className="image">
            <img src="../custom-resources/img/sub_presence_bg.png" alt="" />
          </div>
        </div>
        <div className="breadcrumb">
          <div className="wrap">
            <div className="loca">
              <span>
                <img src="../custom-resources/img/icon_home.png" alt="" />
              </span>
              <span className="on">아소비 입회</span>
            </div>
            <div className="menu">
              <a href="/diagnostic">진단 테스트</a>
              <a href="/sptp" className="on">
                SPTP 종합심리검사
              </a>
              <a href="/branch">우리 동네 아소비</a>
            </div>
          </div>
        </div>
        <div className="sptp">
          <div className="sect sptp01">
            <div className="wrap">
              <div className="tit init">SPTP 종합심리검사</div>
              <div className="txt init">
                {" "}
                <p>아소비 아동 연구소 김상윤 교수의 30여년 간의 연구결과</p>를
                토대로 개발된 SPTP 종합심리검사는 <br />
                1:1 개인 맞춤형 수준별, 능력별 교육과 아동의 건강한 인격 발달을
                위해 사용됩니다.
              </div>
              <div className="dep">
                <ul>
                  <li className="init">
                    <span>하워드 가드너(H.Gardner)의 다중 지능 이론</span>
                  </li>
                  <li className="init">
                    <span>매닝(T.Manning)의 호르몬과 뇌 기능 연구</span>
                  </li>
                  <li className="init">
                    <p>
                      우리 아이의 특성을 정확하게 판단하여
                      <br /> 맞춤형 교육에 필요한 학습 설계를 해 주는{" "}
                      <strong>종합 심리 진단 도구</strong>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="sect sptp02">
            <div className="wrap">
              <div className="tit init">
                SPTP 검사를 통해 우리 아이의 특성을 정확하게 판단합니다.
              </div>
              <div className="img init">
                <i>
                  <img src="../custom-resources/img/img_sptp_sptp02.png" alt="" />
                  <p>
                    <img
                      src="../custom-resources/img/img_sptp_sptp02_p01.png"
                      alt=""
                    />
                  </p>
                  <p>
                    <img
                      src="../custom-resources/img/img_sptp_sptp02_p02.png"
                      alt=""
                    />
                  </p>
                  <p>
                    <img
                      src="../custom-resources/img/img_sptp_sptp02_p03.png"
                      alt=""
                    />
                  </p>
                  <p>
                    <img
                      src="../custom-resources/img/img_sptp_sptp02_p04.png"
                      alt=""
                    />
                  </p>
                  <p>
                    <img
                      src="../custom-resources/img/img_sptp_sptp02_p05.png"
                      alt=""
                    />
                  </p>
                  <p>
                    <img
                      src="../custom-resources/img/img_sptp_sptp02_p06.png"
                      alt=""
                    />
                  </p>
                </i>
              </div>
            </div>
          </div>
          <div className="sect sptp03">
            <div className="wrap">
              <div className="tit init">철저한 진단을 위한 검사 항목</div>
              <div className="txt init">
                모든 요소는 서로 밀접한 영향을 주고받으면서 아동의 건강한 인격
                발달에 영향을 줍니다. <br />
                이를 바탕으로 다양한 검사 후 학습준비도 검사를 통해 전체
                항목으로 심도 있게 분석합니다.
              </div>
              <div className="lst init">
                <ul>
                  <li>
                    <i>
                      <img
                        src="../custom-resources/img/img_sptp_sptp03_img01.png"
                        alt=""
                      />
                    </i>
                    <p>언어능력 검사</p>
                  </li>
                  <li>
                    <i>
                      <img
                        src="../custom-resources/img/img_sptp_sptp03_img02.png"
                        alt=""
                      />
                    </i>
                    <p>논리수학지능 검사</p>
                  </li>
                  <li>
                    <i>
                      <img
                        src="../custom-resources/img/img_sptp_sptp03_img03.png"
                        alt=""
                      />
                    </i>
                    <p>도형조작 검사</p>
                  </li>
                  <li>
                    <i>
                      <img
                        src="../custom-resources/img/img_sptp_sptp03_img04.png"
                        alt=""
                      />
                    </i>
                    <p>자화상 검사</p>
                  </li>
                  <li>
                    <i>
                      <img
                        src="../custom-resources/img/img_sptp_sptp03_img05.png"
                        alt=""
                      />
                    </i>
                    <p>정서태도 검사</p>
                  </li>
                  <li>
                    <i>
                      <img
                        src="../custom-resources/img/img_sptp_sptp03_img06.png"
                        alt=""
                      />
                    </i>
                    <p>학습준비도 검사</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="sect sptp04">
            <div className="bg">
              <img
                src="../custom-resources/img/img_sptp_sptp04.png"
                className="pc-view"
                alt=""
              />
              <img
                src="../custom-resources/img/img_sptp_sptp04_mo.png"
                className="mo-view"
                alt=""
              />
            </div>
            <div className="bg_text">
              <p>
                <span>
                  SPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTP
                </span>
                <span>
                  SPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTP
                </span>
              </p>
              <p>
                <span>
                  SPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTP
                </span>
                <span>
                  SPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTP
                </span>
              </p>
              <p>
                <span>
                  SPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTP
                </span>
                <span>
                  SPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTPSPTP
                </span>
              </p>
            </div>
            <div className="wrap">
              <Swiper
                modules={[Autoplay, Navigation, Mousewheel]}
                autoplay={{
                  delay: 4500,
                  disableOnInteraction: false,
                }}
                loop={true}
                slidesPerView={1}
                navigation={true}
                mousewheel={true}
              >
                <SwiperSlide>
                  <div className="step">STEP 01</div>
                  <div className="stit">언어능력 검사</div>
                  <div className="stxt">
                    언어능력 검사에서는 언어감수성과 언어학습으로 나누어
                    진단합니다.
                    <br className="mo-view" /> <br className="pc-view" />{" "}
                    언어감수성에서 유창성은 사용하는 단어의
                    <br className="mo-view" /> 다양성과 양, 융통성은 다양한
                    범주에 속하는 단어의 사용, <br className="pc-view" />
                    <br className="mo-view" /> 독창성은 독특하고 흔하지 않는
                    단어의 사용을 말합니다. <br className="mo-view" />
                    언어학습은 읽고 쓸 수 있는 수준을 말합니다.
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="step">STEP 02</div>
                  <div className="stit">논리수학지능 검사</div>
                  <div className="stxt">
                    논리수학지능 검사에서는 수 개념과 추리능력으로 나누어
                    진단합니다. <br />수 개념은 수의 이름뿐 아니라 더하기와
                    빼기, 곱셈 등의 개념을
                    <br className="mo-view" /> 의미합니다.{" "}
                    <br className="pc-view" />
                    추리능력은 관계를 파악하고
                    <br className="mo-view" /> 연관된 생각을 할 수 있는 능력을
                    의미합니다.
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="step">STEP 03</div>
                  <div className="stit">도형조작 검사</div>
                  <div className="stxt">
                    도형조작 검사에서는 공간지능과 도형구성력으로 나누어
                    진단합니다. <br />
                    공간지능은 도형 기억, 공간 관계 이해 등을 의미합니다.{" "}
                    <br className="mo-view" />
                    도형구성력에서 정교성은 다룬 조각의 수,{" "}
                    <br className="pc-view" />
                    민감성은 머릿속으로 구성한 <br className="mo-view" />
                    모양을 만들기 시작한 시간(초), 독창성은 순서 짓기(한 줄
                    만들기), <br />
                    포개어 놓기, 세우기 등으로 측정하여 나타낼 수 있습니다.
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="step">STEP 04</div>
                  <div className="stit">자화상 검사</div>
                  <div className="stxt">
                    자화상 검사에서는 자화상의 구성 요소를 분석하여 진단합니다.{" "}
                    <br />
                    자신의 모습을 그림으로 그린 자화상을 통해{" "}
                    <br className="mo-view" />
                    인지 능력에 대한 지능과 정서적인 부분을 측정합니다.{" "}
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="step">STEP 05</div>
                  <div className="stit">정서태도 검사</div>
                  <div className="stxt">
                    정서태도 검사에서는 안정감, 자신감, 주의력으로 나누어
                    진단합니다. <br />
                    안정감은 정서, 자신감은 사회성, 주의력은 학습과 관련이
                    있습니다.{" "}
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="step">STEP 06</div>
                  <div className="stit">학습준비도 검사</div>
                  <div className="stxt">
                    학습준비도 검사에서는 학년에 따른 학기별 문제를 해결하는
                    과정에서 <br />
                    기본(일반 문제), 문장(문장제나 서술형 문제)으로 나누어{" "}
                    <br className="mo-view" />
                    학습 진도를 평가합니다.
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
          <div className="sect sptp05">
            <div className="tit">
              정확한 진단이 <br className="mo-view" /> 아이의 학습 설계에 도움을
              줍니다.{" "}
            </div>
            <div className="txt">
              오랫동안 아소비는 아이의 교육에 대해 고민하였습니다. 그 결과
              아이에게 맞는 학습이 <br /> 아이가 공부를 즐겁고 재미있게{" "}
              <br className="mo-view" />잘 할 수 있도록 한다는 것을 알게
              되었습니다. <br />
              그래서 무엇보다 첫 시작이 중요합니다. <br />
              우리 아이에게 맞는 <b>맞춤형 교육</b>, <br className="mo-view" />
              아소비에서만 제시해 줄 수 있습니다.
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Sptp;
